import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const translateService = inject(TranslateService);
  const currentLanguage = translateService.getCurrentLang();

  const clonedRequest = req.clone({
    headers: req.headers.set('Accept-Language', currentLanguage),
  });

  return next(clonedRequest);
};
